import { render, staticRenderFns } from "./AgencyRanking.vue?vue&type=template&id=977f772c&scoped=true&"
import script from "./AgencyRanking.vue?vue&type=script&lang=js&"
export * from "./AgencyRanking.vue?vue&type=script&lang=js&"
import style0 from "./AgencyRanking.vue?vue&type=style&index=0&id=977f772c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977f772c",
  null
  
)

export default component.exports